import { pageDto } from "./pagedto";
import { AcademicFeeDto } from './academicfeedto';

export class AcademicFeeResponse {

    listAcademicFeeDto: AcademicFeeDto[] = [];

    pageDto: pageDto = new pageDto({});

}